var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.5,
    height: 18.503,
    viewBox: "0 0 18.5 18.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-instagram",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M18.4,5.293a6.578,6.578,0,0,0-.418-2.184A4.612,4.612,0,0,0,15.35.475,6.6,6.6,0,0,0,13.166.056C12.2.011,11.9,0,9.452,0S6.7.011,5.742.053A6.58,6.58,0,0,0,3.558.471a4.393,4.393,0,0,0-1.6,1.041A4.433,4.433,0,0,0,.923,3.106,6.6,6.6,0,0,0,.5,5.29C.459,6.253.449,6.559.449,9s.011,2.75.053,3.71A6.578,6.578,0,0,0,.92,14.9a4.611,4.611,0,0,0,2.634,2.634,6.6,6.6,0,0,0,2.184.418C6.7,17.993,7,18,9.449,18s2.75-.01,3.71-.053a6.577,6.577,0,0,0,2.184-.418A4.6,4.6,0,0,0,17.977,14.9a6.6,6.6,0,0,0,.418-2.184c.042-.96.053-1.266.053-3.71s0-2.75-.046-3.71Zm-1.621,7.351a4.935,4.935,0,0,1-.31,1.671,2.986,2.986,0,0,1-1.709,1.709,4.952,4.952,0,0,1-1.671.309c-.95.042-1.234.053-3.637.053s-2.69-.01-3.637-.053a4.932,4.932,0,0,1-1.671-.309,2.77,2.77,0,0,1-1.034-.672,2.8,2.8,0,0,1-.672-1.034,4.953,4.953,0,0,1-.309-1.671c-.042-.95-.053-1.235-.053-3.637s.01-2.69.053-3.637A4.932,4.932,0,0,1,2.443,3.7a2.736,2.736,0,0,1,.675-1.034A2.8,2.8,0,0,1,4.152,2a4.955,4.955,0,0,1,1.671-.31c.95-.042,1.235-.053,3.636-.053s2.691.011,3.637.053A4.935,4.935,0,0,1,14.766,2a2.768,2.768,0,0,1,1.034.672A2.8,2.8,0,0,1,16.472,3.7a4.955,4.955,0,0,1,.31,1.671c.042.95.053,1.234.053,3.637s-.011,2.683-.053,3.633Zm0,0",
    transform: "translate(-0.449)",
    fill: "#f4f4fa",
    stroke: "#f4f4fa",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_31",
    "data-name": "Caminho 31",
    d: "M129.574,124.5a4.625,4.625,0,1,0,4.625,4.625A4.626,4.626,0,0,0,129.574,124.5Zm0,7.625a3,3,0,1,1,3-3A3,3,0,0,1,129.574,132.125Zm0,0",
    transform: "translate(-120.57 -120.121)",
    fill: "#f4f4fa",
    stroke: "#f4f4fa",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_32",
    "data-name": "Caminho 32",
    d: "M364.609,89.681a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,364.609,89.681Zm0,0",
    transform: "translate(-349.718 -85.486)",
    fill: "#f4f4fa",
    stroke: "#f4f4fa",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInstagram);
export default __webpack_public_path__ + "static/media/ico-instagram.d8bc7fc585cf233c76b29b9047f516ed.svg";
export { ForwardRef as ReactComponent };